import { PureComponent } from "react";
import { StyledComparisonFeatureComponent } from "./comparison-feature-component.scss";
import VIcon from "/static/svg/competitors-template/v.svg";
import XIcon from "/static/svg/competitors-template/x.svg";

export default class ComparisonFeatureComponent extends PureComponent {
  renderFeatureValueContnet(value) {
    if (value === "true") return <VIcon fill="#00D647" />;
    if (value === "false") return <XIcon />;
    return value;
  }

  renderFeatureValue(value) {
    return <div className="feature-value">{this.renderFeatureValueContnet(value)}</div>;
  }

  render() {
    const { title, monday, competitor, index, bigTexts } = this.props;
    return (
      <StyledComparisonFeatureComponent className="table-row-wrapper">
        <div className={`table-row table-feature ${index % 2 == 0 ? "even" : "odd"} ${bigTexts ? "big-texts" : ""}`}>
          <div className="table-cell first-cell">{title}</div>
          <div className="table-cell">{this.renderFeatureValue(monday)}</div>
          <div className="table-cell" />
          <div className="table-cell">{this.renderFeatureValue(competitor)}</div>
          <div className="table-cell" />
        </div>

        <div className={`mobile-table-row ${bigTexts ? "big-texts" : ""}`}>
          <div className="feature-title">{title}</div>
          <div className="feature-cells">
            <div className="table-cell">{this.renderFeatureValue(monday)}</div>
            <div className="table-cell">{this.renderFeatureValue(competitor)}</div>
          </div>
        </div>
      </StyledComparisonFeatureComponent>
    );
  }
}

ComparisonFeatureComponent.defaultProps = {
  title: null,
  monday: null,
  competitor: null
};
